<template>
  <div class="l-bg" @click.stop="hidden">
    <LeftNav :leftdatalist="leftdatalist"></LeftNav>
    <HeaderCommon ref="header" @changepassword="changepassword" :islogout="islogout"></HeaderCommon>
    <div class="contentclass">
      <router-view  />
    </div>
    <el-dialog
      width="500px"
      z-index="1000"
      title="修改密码"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      lock-scroll
      key="1"
      top="20vh"
    >
      <div class="content">
        <div class="inputclass">
          <div class="left">新密码：</div>
          <el-input placeholder="请输入新密码" v-model="newpassword"></el-input>
        </div>
        <div class="inputclass">
          <div class="left">确认新密码：</div>
          <el-input placeholder="请确认新密码" v-model="confirmpassword"></el-input>
        </div>
        <button class="submitclass" @click="submitclick">提交</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import HeaderCommon from '../components/HeaderCommon/index'
  import LeftNav from '../components/LeftNav/index'
  import * as api from "../utils/api"
  import ElDialog from "element-ui/packages/dialog/src/component";

  export default {
    components: {
      ElDialog,
      HeaderCommon,
      LeftNav
    },
    data() {
      return {
        dialogFormVisible:false,
        leftdatalist:[],
        newpassword:'',
        confirmpassword:'',
        islogout:false,
      }
    },
    computed: {
    },
    mounted() {
      this.getUserButton();
    },
    methods: {
      getUserMenu(){
        var self = this;
        api.getUserMenu({})
          .then(rs => {
            if (rs.status == 200) {
              self.leftdatalist=rs.data;
              self.$store.commit('SET_Menulist', rs.data);

            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            // self.$message.error(err)
            // self.loading=false;

          })
      },
      getUserButton(){
        // this.loading=true;
        var self = this;
        api.getUserButton({})
          .then(rs => {
            // self.loading=false;
            if (rs.status == 200) {

              self.$store.commit('SET_UserButton', rs.data);


            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            // self.$message.error(err)
            // self.loading=false;

          })
      },
      hidden() {
        this.$nextTick(() => {
          if (this.$refs.header) this.$refs.header.hidden()
        })
      },
      submitclick(){

        if(!this.newpassword||!this.confirmpassword){
          this.$message.error('请输入新密码')
          return;
        }
        if(this.newpassword!=this.confirmpassword){
          this.$message.error('两次输入密码不一致！')
          return;
        }
        this.updatePwd();
      },
      updatePwd(){
        var self = this;
        api.updatePwd({
          "userId":LocalStorage.get('datacollect_userId'),
          "pwd":this.confirmpassword
        })
          .then(rs => {

            if (rs.status == 200) {
              self.$message({
                message: '修改成功，请重新登录！',
                type: 'success'
              });
              self.islogout=true;

            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            // self.$message.error(err)
            // self.loading=false;

          })
      },
      changepassword(){
        this.dialogFormVisible=true
      }

    }
  }
</script>

<style lang="less" scoped>
  .l-bg {
    /*background-color: #fff;*/
  }
  .contentclass{
    width: calc(100% - 240px);
    margin-left: 200px;
    height: calc(100% - 70px);
    margin-top: 70px;
    min-height: 100%;
    background: #f5f6fa;
    padding: 20px;
  }
  .content{
    width: 400px;
    margin: 0 auto;
    margin-bottom: 10px;
    text-align: center;
    .inputclass{
      display: flex;
      margin-top: 20px;
      .left{
        width: 100px;
        text-align: right;
        line-height: 32px;
      }
      /deep/.el-input{
        width: 320px !important;
      }

    }
    .submitclass{
      margin-top: 30px;
      width: 200px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/layout.vue